import { useEffect, useState } from "react";
import { Button, Input, TextField } from "@heroui/react";
import { helpStore } from "@/stores/HelpStore";
import type { HelpOrderDetail } from "../types";

interface HelpLatManualFieldsProps {
  order: HelpOrderDetail;
}

const HelpLatManualFields: React.FC<HelpLatManualFieldsProps> = ({ order }) => {
  const [latOrderId, setLatOrderId] = useState(order.latOrderId ?? "");
  const [latStatusRaw, setLatStatusRaw] = useState(order.latStatusRaw ?? "");
  const [latShortLink, setLatShortLink] = useState(order.latShortLink ?? "");
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setLatOrderId(order.latOrderId ?? "");
    setLatStatusRaw(order.latStatusRaw ?? "");
    setLatShortLink(order.latShortLink ?? "");
  }, [order.uuid, order.latOrderId, order.latStatusRaw, order.latShortLink]);

  const dirty =
    latOrderId.trim() !== (order.latOrderId ?? "") ||
    latStatusRaw.trim() !== (order.latStatusRaw ?? "") ||
    latShortLink.trim() !== (order.latShortLink ?? "");

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await helpStore.saveLatManual({ latOrderId, latStatusRaw, latShortLink });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="help-lat-manual">
      <p className="help-lat-manual__hint">
        Если ЛАТ не принял заявку сам, впишите номер заказа. Пустой номер отвязывает заявку от ЛАТ.
      </p>
      <label className="help-form-field">
        Номер в ЛАТ
        <TextField fullWidth>
          <Input
            value={latOrderId}
            maxLength={32}
            onChange={(event) => setLatOrderId(event.target.value)}
            placeholder="OrderID"
          />
        </TextField>
      </label>
      <div className="help-lat-manual__grid">
        <label className="help-form-field">
          Статус ЛАТ
          <TextField fullWidth>
            <Input
              value={latStatusRaw}
              maxLength={64}
              onChange={(event) => setLatStatusRaw(event.target.value)}
              placeholder="Как в кабинете ЛАТ"
            />
          </TextField>
        </label>
        <label className="help-form-field">
          Ссылка
          <TextField fullWidth>
            <Input
              value={latShortLink}
              maxLength={500}
              onChange={(event) => setLatShortLink(event.target.value)}
              placeholder="https://"
            />
          </TextField>
        </label>
      </div>
      <Button
        size="sm"
        variant="primary"
        isDisabled={!dirty || isSaving}
        onPress={() => void handleSave()}
      >
        {isSaving ? "Сохранение…" : "Сохранить данные ЛАТ"}
      </Button>
    </div>
  );
};

HelpLatManualFields.displayName = "HelpLatManualFields";
export default HelpLatManualFields;
